<template>
    <insufficient-on-hand-dialog :openInsufficientOnHandDialog="openInsufficientOnHandDialog" :partsList="insufficientPartsList"  :mode="'update'" :sourcePage="'OrderParts'" @closeInsOnHandDialog="closeInsOnHandDialog" @removeFromCart="removeFromCart" />
    <div class="cart__table cart-table">
        <table class="cart-table__table" v-if="items.length > 0">
        <tbody class="cart-table__body">
            <template v-for="item in standardItems" :key="item.cartindex">
                <tr v-if="item.printHeader === 'Y'" class="cart-locations-row">
                    <td colspan="7" class="cart-locations">
                    {{ (customerIndicator == 'B') ? item.locationcity : ''}}
                    </td>
                </tr>
                <tr class="cart-table__head cart-table__head-locations" v-if="item.printHeader === 'Y'">
                    <th class="cart-table__column cart-table__column--image-locations">Image</th>
                    <th class="cart-table__column cart-table__column--quantity-locations">Quantity</th>
                    <th class="cart-table__column cart-table__column--product-locations">Product</th>
                    <th class="cart-table__column cart-table__column--price-locations">Price</th>
                    <th class="cart-table__column cart-table__column--numeral-locations">Availability</th>
                    <th class="cart-table__column cart-table__column--total-locations">Total</th>
                    <th class="cart-table__column cart-table__column--remove-locations"><img src="images/spacer.png" width="20px"></th>
                </tr>
                <tr class="cart-table__row">
                    <td class="cart-table__column cart-table__column--image">
                        <div class="image image--type--product modal-thumbnail">
                            <base-link url="/part/&_parm" :parms="[item.manufacturer + '/' + item.sku + '/' + item.mfgSeo + '/' + item.itemSeo]" class="image__body" v-if="item.image != ''">
                                <img class="image__tag" :src="item.image" :alt="item.desc" />
                            </base-link>
                        </div>
                    </td>
                    <td class="cart-table__column cart-table__column--quantity" data-title="Quantity">
                        <base-quantity-input v-model="item.pageQty" @changedQty="changedQty(item)" v-if="item.kit_items == undefined"></base-quantity-input>
                    </td>
                    <td class="cart-table__column cart-table__column--product">
                        <router-link :to="'/part/' + item.manufacturer + '/' + item.sku + '/' + item.mfgSeo + '/' + item.itemSeo" class="cart-table__product-name">{{ item.desc }}</router-link>
                        
                        <div class="text-cart-item-number" v-if="item.XRITMC">
                            <span class="text-cart-item-number">Item: {{ item.XRITMC }}</span>
                            <span class="text-cart-item-number">({{ item.sku }})</span>
                        </div>
                        <div class="text-cart-item-number" v-else>
                            <span class="text-cart-item-number">Item: {{ item.sku }}</span>
                        </div>

                        <div class="text-cart-item-manufacturer">
                            <span class="text-cart-item-manufacturer">Manufacturer: {{ item.manufacturer }}</span>
                        </div>

                        <kit-components v-if="item.kit_items != undefined" :kit_components="item.kit_items"></kit-components>
                    </td>

                    <td class="cart-table__column cart-table__column--price" data-title="Price">
                        <p class="cart-table--price">
                            <strong>Your Price: <span class='notranslate'>{{ toUSD(item.yourprice) }}</span></strong><br />
                            <strong v-if="(item.corecharge > 0) && EKKITF == ''" >
                                Core Charge: <span class="text-danger notranslate">{{ toUSD(item.corecharge) }}</span>
                                <br />
                            </strong>
                            <!-- <span v-if="EKKITF == ''">
                            List Price: <span class='notranslate'>{{ toUSD(item.listprice) }}</span>
                            </span> -->
                        </p>
                    </td>

                    <td class="cart-table__column cart-table__column--numeral" data-title="Status">
                        <availability-display :stock-quantity="item.stockquantity" />
                    </td>
                    <!-- <td class="cart-table__column cart-table__column--numeral" data-title="Shipping">
                        <strong><span class="text-success">{{ item.shipping }}</span></strong>
                    </td> -->               
                    <td class="cart-table__column cart-table__column--total" data-title="Total">
                        <!-- Unable to use computed property here and method triggers for all rows when one row changes -->
                        <strong class='notranslate' v-if="item.kit_items != undefined">
                            {{ toUSD(item.yourprice) }}
                        </strong>
                        <strong class='notranslate' v-else>
                            {{ toUSD(item.linetotal = item.pageQty > 0 ? ((item.pageQty * item.yourprice) + item.corecharge).toFixed(2) : '0') }}
                        </strong>
                    </td>
                    <td class="cart-table__column cart-table__column--remove">
                        <a href="javascript:void(0)" @click.prevent="removeCartLine(item.cartindex, item.EKKITF)">
                            <svg
                            width="25"
                            height="25"
                            viewBox="0 0 32 32"
                            class="cart-X-svg cart-table__remove"
                            >
                            <path
                                d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"
                            ></path>
                            </svg>
                        </a>
                    </td>
                </tr>
            </template>
            
            <template v-for="(item, index) in backorderItems" :key="item.cartindex">
                <tr v-if="index === 0" class="cart-locations-row">
                    <td colspan="7" class="cart-locations">
                        Backordered Items
                    </td>
                </tr>
                <tr class="cart-table__head cart-table__head-locations" v-if="index === 0">
                    <th class="cart-table__column cart-table__column--image-locations">Image</th>
                    <th class="cart-table__column cart-table__column--quantity-locations">Quantity</th>
                    <th class="cart-table__column cart-table__column--product-locations">Product</th>
                    <th class="cart-table__column cart-table__column--price-locations">Price</th>
                    <th class="cart-table__column cart-table__column--numeral-locations">Status</th>
                    <th class="cart-table__column cart-table__column--total-locations">Total</th>
                    <th class="cart-table__column cart-table__column--remove-locations"><img src="images/spacer.png" width="20px"></th>
                </tr>
                <tr class="cart-table__row">
                    <td class="cart-table__column cart-table__column--image">
                        <div class="image image--type--product">
                            <base-link url="/part/&_parm" :parms="[item.sku]" class="image__body" v-if="item.image != ''">
                                <img class="image__tag" :src="item.image" :alt="item.desc" />
                            </base-link>
                        </div>
                    </td>
                    <td class="cart-table__column cart-table__column--quantity" data-title="Quantity">
                        <base-quantity-input v-model="item.pageQty" @changedQty="changedQty(item)"></base-quantity-input>
                    </td>
                    <td class="cart-table__column cart-table__column--product">
                        <router-link :to="'/part/' + item.manufacturer + '/' + item.sku + '/' + item.mfgSeo + '/' + item.itemSeo" class="cart-table__product-name">{{ item.desc }}</router-link>
                        <div class="text-cart-item-number">
                            <span class="text-cart-item-number">Item: {{ item.sku }}</span>
                            <span class="text-cart-item-number" v-if="item.XRITMC">({{ item.XRITMC }})</span>
                        </div>
                        <div class="text-cart-item-manufacturer"><span class="text-cart-item-manufacturer">Manufacturer: {{ item.manufacturer }}</span></div>
                        <!-- <div class="text-cart-item-number">
                            <span class="text-cart-item-number">Item: {{ item.sku }}</span>
                        </div> 
                        <router-link to="/dms-product-sidebar-ac-delco-battery" class="cart-table__product-name">{{ item.desc }}</router-link><br>										
                        <div class="text-cart-item-manufacturer">
                            <span class="text-cart-item-manufacturer">Manufacturer: {{ item.manufacturer }}</span>
                        </div>	 -->
                    </td>

                    <td class="cart-table__column cart-table__column--price" data-title="Price">
                        <p class="cart-table--price">
                            <strong>Your Price: <span class='notranslate'>{{ toUSD(item.yourprice) }}</span></strong><br />
                            <strong v-if="item.corecharge > 0">
                                Core Charge: <span class="text-danger notranslate">{{ toUSD(item.corecharge) }}</span>
                                <br />
                            </strong>
                            <!-- List Price: <span class='notranslate'>{{ toUSD(item.listprice) }}</span> -->
                        </p>
                    </td>

                    <td class="cart-table__column cart-table__column--numeral" data-title="Status">
                        <availability-display :stock-quantity="item.stockquantity" :backordered="true" />
                    </td>
                    <!-- <td class="cart-table__column cart-table__column--numeral" data-title="Shipping">
                        <strong><span class="text-success">{{ item.shipping }}</span></strong>
                    </td> -->


                    
                    <td class="cart-table__column cart-table__column--total" data-title="Total">
                        <!-- Unable to use computed property here and method triggers for all rows when one row changes -->
                        <strong class='notranslate'>{{ toUSD(item.linetotal = item.pageQty > 0 ? ((item.pageQty * item.yourprice) + item.corecharge).toFixed(2) : '0') }}</strong>
                    </td>
                    <td class="cart-table__column cart-table__column--remove">
                        <a href="javascript:void(0)" @click.prevent="removeCartLine(item.cartindex, '')">
                            <svg
                            width="25"
                            height="25"
                            viewBox="0 0 32 32"
                            class="cart-X-svg cart-table__remove"
                            >
                            <path
                                d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"
                            ></path>
                            </svg>
                        </a>
                    </td>
                </tr>
            </template>
        </tbody>
        <tfoot class="cart-table__foot">
            <tr>
            <td colspan="12">
                <div class="cart-table__actions">
                    <form class="cart-table__coupon-form form-row">
                        <div class="form-group mb-0 row flex-grow-1">
                            <input
                                type="text"
                                class="form-control form-control-sm promo-form-field"
                                placeholder="Promo Code"
                                v-model="code"
                                @keypress.enter="validate_code" />
                                <div class="btn-primary--promo">
                                    <button type="button" class="btn btn-sm btn-primary" @click="validate_code">
                                        Apply
                                    </button>
                                </div>
                        </div>
                    </form>
                    
                    <div class="cart-table__update-button">
                        <button type="button" class="btn btn-sm btn-secondary" @click.prevent="clearCartClicked">Clear Cart</button>
                        <button type="button" class="btn btn-sm btn-primary" @click.prevent="updateCart">Update Cart</button>
                    </div>                    
                </div>
                <div class="cart-table__actions" v-if="showAlert">
                    <p class="m-0"> <strong>Alert!</strong> Press Update Cart to apply the changes in quantity</p>
                </div>
            </td>
            </tr>
        </tfoot>
        </table>
        <!-- <p class="cart-table__table mt-3 text-center" v-else>
            You do not have items in your cart.
        </p> -->
        <div class="document__content card" v-else>
            <h4>You must make a selection in order to get search results.</h4>                     
        </div>
    </div>

    <base-dialog title="Confirm Delete" @close="cancelRemove" :open="selectedCartIndex != null">
        <template #default>
            <p>Are you sure you want to remove this item?</p>
        </template>
        <template #actions>
            <button type="button" class="btn btn-sm btn-secondary" @click="cancelRemove">
            Cancel
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="confirmRemove">
            Ok
            </button>

        </template>
    </base-dialog>

    <base-dialog title="Clear Cart?" @close="cancelClearCart" :open="isClearCartDialogOpen">
        <template #default>
            <p>Are you sure you want to clear your cart?</p>
        </template>
        <template #actions>
            <button type="button" class="btn btn-sm btn-secondary" @click="cancelClearCart">
                Cancel
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="confirmClearCart">
                Ok
            </button>
        </template>
    </base-dialog>

    <!-- show alert dialog on change of quantity -->
    <base-dialog title="Alert!" @close="cancelRemove" :open="showAlertDialog">
        <template #default>
            <p>Press Update Cart to apply the changes in quantity</p>
        </template>
        <template #actions>
            <button type="button" class="btn btn-sm btn-primary" @click="hideAlert">
            Ok
            </button>
        </template>
    </base-dialog>

    <!-- show ALERT message for code validation -->
    <base-dialog :title="codeAlertTitle" @close="alertCode = false" :open="alertCode">
        <template #default>
            <p>{{ codeAlertMsg }}</p>
        </template>
        <template #actions>
            <button type="button" class="btn btn-sm btn-primary" @click="alertCode = false">
            Ok
            </button>
        </template>
    </base-dialog>
    <base-spinner :open="isloading"></base-spinner>
</template>

<script>
import AvailabilityDisplay from './AvailabilityDisplay.vue';
import InsufficientOnHandDialog from "./InsufficientOnHandDialog";
import KitComponents from './KitComponents.vue';
import Price from '../../../mixins/price.js';
import MixinCart from '../../../mixins/cart.js';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {
    components: {
        "availability-display": AvailabilityDisplay,
        "insufficient-on-hand-dialog": InsufficientOnHandDialog,
        KitComponents
    },
    mixins: [ 
        Price,
        MixinCart,
    ],
    data() {
        return {
            isloading: false,
            items: [],
            selectedCartIndex: null,
            alertmsg: 'Press this button to apply the changes in quantity',
            showAlert: false,
            showAlertDialog: false,
            shownDialog: false,
            isClearCartDialogOpen: false,
            insufficientPartsList: {},
            openInsufficientOnHandDialog: false,
            code: '',
            alertCode: false,
            codeAlertTitle: '',
            codeAlertMsg: '',
            toDelete: '',
        }        
    },
    methods: {
        updateCart() {
            this.items.forEach((item) => {
                let linetotal = 0;

                linetotal = item.pageQty * item.extended_price;

                let productData = {
                    ID: item.sku,
                    linenumber: item.linenumber,
                    item: item.sku,
                    desc: item.desc,
                    manufacturer: item.manufacturer,
                    image: item.image,
                    quantity: item.pageQty,
                    listprice: item.listprice,
                    corecharge: item.corecharge,
                    yourprice: item.yourprice,
                    shipping: 0,
                    linetotal: linetotal,
                    stockquantity: item.stockquantity,
                    locationid: item.cartlocationid,
                    locationname: item.cartlocationname,
                    locationcity: item.cartlocationcity,
                    locationstate: item.cartlocationstate,
                    backorder: item.backorder,
                    isupdating: true,

                    XRMFGC: item.XRMFGC,
                    XRITMC: item.XRITMC,
                    IMIGSA: item.IMIGSA,
                    IMISVALID: item.IMISVALID,
                }

                let validationresult = this.addToCartValidation(productData);

                if (validationresult.status === 'OK') {
                    this.$store.dispatch("cart/updateCart", productData);
                } else {
                    let storedmessages = [];
                    storedmessages.push(validationresult.message);

                    this.$store.dispatch("message/addKeyedMessage", {
                        "key": "OrderParts",
                        "messages": storedmessages
                    });
                }
            });
        },
        removeCartLine(index, kit_or_item) {
            this.toDelete = kit_or_item;
            this.selectedCartIndex = index;
        },
        confirmRemove() {
            // console.log(this.toDelete);
            // return;
            if(this.toDelete == '' || this.toDelete == undefined){
                this.$store.dispatch('cart/removeCartLine', { "index": this.selectedCartIndex });   
            }

            if(this.toDelete == 'M'){
                this.$store.dispatch('cart/removeKitLine', { "index": this.selectedCartIndex });
            }

            this.buildCartListDisplay();
            this.selectedCartIndex = null;
        },
        cancelRemove() {
            this.selectedCartIndex = null;
        },
        // changedQty(requestedqty, stockqty) {
        //     console.log(requestedqty + ' - ' + stockqty);
        changedQty(parts) {
            this.insufficientPartsList = {};
            if (this.customerIndicator === 'B' && parts.pageQty > parts.stockquantity) {
                this.openInsufficientOnHandDialog = true;

                this.insufficientPartsList = {
                    "cartindex": parts.cartindex,
                    "linenumber": parts.linenumber,
                    "manufacturer": parts.manufacturer,
                    "item": parts.sku,
                    "itemdesc": parts.desc,
                    "stockquantity": parts.stockquantity,
                    "location": parts.locationid,
                    "requestedquantity": parts.pageQty
                }

                this.showAlert = true;
            } else {
                if (!this.shownDialog) {
                    this.showAlert = true;
                    this.showAlertDialog = true;
                }
            }
        },
        hideAlert() {
            this.showAlertDialog = false;
            this.shownDialog = true;
        },
        async buildCartListDisplay() {
            this.items = [];

            this.cart.forEach((item, i) => {
                // console.log(item);
                let itemlocationid = '', itemlocationname = '', itemlocationcity = '', itemlocationstate = '', itemlocationsequence = 0;

                if (item.locationid === undefined) {
                    itemlocationid = this.getDefaultLocationDetails.defaultlocationid;
                    itemlocationname = this.getDefaultLocationDetails.defaultlocationname;
                    itemlocationcity = this.getDefaultLocationDetails.defaultlocationcity;
                    itemlocationstate = this.getDefaultLocationDetails.defaultlocationstate;
                } else {
                    itemlocationid = item.locationid;
                    itemlocationname = item.locationname;
                    itemlocationcity = item.locationcity;
                    itemlocationstate = item.locationstate;
                }

                // console.log(this.customerlocationlist.find(loc => loc.locationid === itemlocationid));
                const custloc = this.customerlocationlist.find(loc => loc.locationid === itemlocationid);
                if(custloc != undefined){
                    itemlocationsequence = custloc.locationsequence;
                }else{
                    itemlocationsequence = '';
                }

                let cartdata = {
                    "cartindex": i,
                    "ID": item.ID,
                    "linenumber": item.linenumber,
                    "sku": item.item,
                    "desc": item.desc,
                    "manufacturer": item.manufacturer,
                    "image": item.image,
                    "quantity": item.quantity,
                    "listprice": item.listprice,
                    "corecharge": item.corecharge,
                    "yourprice": item.yourprice,
                    "shipping": item.shipping,
                    "linetotal": item.linetotal,
                    "stockquantity": item.stockquantity,
                    "backorder": item.backorder,
                    "cartlocationid": item.locationid,
                    "cartlocationname": item.locationname,
                    "cartlocationcity": item.locationcity,
                    "cartlocationstate": item.locationstate,
                    "locationid": itemlocationid,
                    "locationname": itemlocationname,
                    "locationcity": itemlocationcity,
                    "locationstate": itemlocationstate,
                    "locationsequence": itemlocationsequence,
                    "pageQty": item.quantity,
                    "printHeader": "N",
                    "EKKITF" : '',

                    "itemSeo": item.itemSeo,
                    "mfgSeo": item.mfgSeo,
                    
                    "XRMFGC": item.XRMFGC,
                    "XRITMC": item.XRITMC,
                    "IMIGSA": item.IMIGSA,
                    "IMISVALID": item.IMISVALID,
                }
                this.items.push(cartdata);
            });

            // console.log(this.kits);

            this.kits.forEach((item, i) => {

                let itemlocationid = '', itemlocationname = '', itemlocationcity = '', itemlocationstate = '', itemlocationsequence = 0;

                if (item.locationid === undefined) {
                    itemlocationid = this.getDefaultLocationDetails.defaultlocationid;
                    itemlocationname = this.getDefaultLocationDetails.defaultlocationname;
                    itemlocationcity = this.getDefaultLocationDetails.defaultlocationcity;
                    itemlocationstate = this.getDefaultLocationDetails.defaultlocationstate;
                } else {
                    itemlocationid = item.locationid;
                    itemlocationname = item.locationname;
                    itemlocationcity = item.locationcity;
                    itemlocationstate = item.locationstate;
                }

                // console.log(this.customerlocationlist.find(loc => loc.locationid === itemlocationid));
                const custloc = this.customerlocationlist.find(loc => loc.locationid === itemlocationid);
                if(custloc != undefined){
                    itemlocationsequence = custloc.locationsequence;
                }else{
                    itemlocationsequence = '';
                }

                let kitData = {
                    "cartindex": i,
                    "ID": item.kitnumber,
                    // "linenumber": item.linenumber,
                    "sku": item.kitnumber,
                    "desc": item.desc,
                    "manufacturer": item.manufacturer,
                    "image": item.image,
                    "quantity": item.quantity,
                    "listprice": item.listprice,
                    "corecharge": item.corecharge,
                    "yourprice": item.kit_gtotal,
                    "shipping": item.shipping,
                    "linetotal": item.kit_gtotal,
                    "stockquantity": item.quantity,
                    "backorder": item.backorder,
                    "cartlocationid": item.locationid,
                    "cartlocationname": item.locationname,
                    "cartlocationcity": item.locationcity,
                    "cartlocationstate": item.locationstate,
                    "locationid": itemlocationid,
                    "locationname": itemlocationname,
                    "locationcity": itemlocationcity,
                    "locationstate": itemlocationstate,
                    "locationsequence": itemlocationsequence,
                    "pageQty": item.quantity,
                    "printHeader": "N",
                    "EKKITF" : item.EKKITF,
                    kit_items: item.kit_items,
                    
                    "XRMFGC": item.XRMFGC,
                    "XRITMC": item.XRITMC,
                    "IMIGSA": item.IMIGSA,
                    "IMISVALID": item.IMISVALID,
                }
                this.items.push(kitData);
            });



            this.items.sort((a,b) => (a.locationsequence > b.locationsequence) ? 1 : ((b.locationsequence > a.locationsequence) ? -1 : 0));

            let prevlocationid = '';

            // Add flags for each unique location after sorting to handle the display
            this.items.forEach((item, i) => {
                let isbackorder = item.backorder ? true : false;
                if (!isbackorder) {
                    if (i === 0 || prevlocationid != item.locationid) {
                        prevlocationid = item.locationid;
                        this.items[i].printHeader = 'Y';
                    }
                }
            });

            // console.log(this.items);
        },
        addItemsToList(cartList) {
            for (let x = 0; x < cartList.length; x++) {
                let item = cartList[x];
                item.pageQty = item.quantity;
                item.cartindex = x;
                this.items.push(item);
            }
        },
        clearCartClicked() {
            this.isClearCartDialogOpen = true;
        },
        cancelClearCart() {
            this.isClearCartDialogOpen = false;
        },
        confirmClearCart() {
            this.$store.dispatch("cart/emptyCart");
            this.isClearCartDialogOpen = false;
        },
        closeInsOnHandDialog() {
            this.openInsufficientOnHandDialog = false;
        },
        removeFromCart(cartindex) {
            this.$store.dispatch('cart/removeCartLine', { "index": cartindex });
            this.buildCartListDisplay();
            this.selectedCartIndex = null;
        },
        validate_code() {
            this.isloading = true;
            this.error_msg = '';
            this.success_msg = '';

            const isApplied = this.promo_code.find(promo => promo.code == this.code);
            // this.$store.dispatch('cart/emptyPromo');

            if(isApplied != undefined) {
                this.error_code = true;
                this.error_msg = 
                this.isloading = false;

                this.codeAlertTitle = 'WARNING! ';
                this.codeAlertMsg = 'Promo code ' + this.code + ' is already applied.';
                this.alertCode = true;
                return false;
            }

            axiosvl.post(this.$store.getters['api/promo_code_uri'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							// "HOSTURL": {"value": this.$store.getters.hosturl},
                            "LW3SFID": { "value": this.$store.getters.storefront },
							"LW3PROCOD": {"value": this.code},
						}
					}
				}
			).then((response) => { 
                this.alertCode = true;
                this.isloading = false;
				const fields = response.data.webroutine.fields;
                const DC_DETAILS = response.data.webroutine.lists.DC_DETAILS.entries;

                // console.log(DC_DETAILS);
				if (fields.RET_CODE.value == 'ER'){
                    this.error_code = true;
                    this.error_msg = 'Promo code ' + this.code + ' is invalid.'
                    this.promo_accepted = false;

                    this.codeAlertTitle = 'Failed!';
                    this.codeAlertMsg = 'Promo code ' + this.code + ' is invalid.';
                }else{
                    this.codeAlertTitle = 'Success!';
                    this.codeAlertMsg = 'Promo code ' + this.code + ' successfully applied.'

                    this.error_code = false;
                    this.promo_accepted = true;
                    this.success_msg = 'Promo code ' + this.code + ' successfully applied.';

                    console.log('RET_CODE : ' + fields.RET_CODE.value);
                    DC_DETAILS.forEach(dc => {
                        // console.log(dc);

                        // UPDATE ORDER TOTAL
                        const promo_details = {
                            main_desc : fields.LW3PRONM.value,
                            code    : this.code,
                            fixed_dc: dc.LW3DOLDIS,
                            percent_dc: dc.LW3PCTDIS,
                            to_item: dc.LW3ITEMCD,
                            to_sag: dc.LW3SSHPTP,
                            sequence: dc.LW3SEQ,
                            amnt_dc: 0,
                        };

                        // console.log(promo_details);

                        // set promo code to the state
                        this.$store.dispatch('cart/setPromo_code', promo_details);// UPDATE ORDER TOTAL
                    });

                    // // recalculate the totals
                    this.$store.dispatch('cart/calculateTotals');
                }

			}).catch(function (error) { 
				console.error("error - " + error);
			});
        }
    },
    computed: {
        ...mapGetters([
            "image_domain_category",
            "getDefaultLocationDetails",
            "customerIndicator"
        ]),
        ...mapGetters("cart", [
            "cart",
            'promo_code',
            'kits'
        ]),
        standardItems() {
            return this.items.filter((item) => { return !item.backorder });
        },
        backorderItems() {
            return this.items.filter((item) => { return item.backorder });
        }
    },
    watch: {
        cart: {
            deep: true,
            // handler: function(newVal, oldVal) {
            handler: function() {
                this.buildCartListDisplay();

                // const array2Sorted = oldVal.slice().sort();
                // const similararrays = newVal.length === oldVal.length && newVal.slice().sort().every(function(value, index) {
                //     return value === array2Sorted[index];
                // });

                // if (!similararrays) {
                // this.items = [];
                // this.cart.forEach(item => {
                //   item.pageQty = item.quantity;
                //   this.items.push(item);
                // });
                // }
            }
        },
    },
    mounted() {
        this.showAlert = false, this.showAlertDialog = false, this.showDialog = false, this.isClearCartDialogOpen = false, this.openInsufficientOnHandDialog = false;
        this.insufficientPartsList = {};

        this.mx_getLocationDetails();
        this.buildCartListDisplay();
    },

    updated() {
        // console.log('updated order list');
    }
}
</script>